__webpack_require__.p = "https://static.shieldguard.xyz/";